// 9fbef606107a605d69c0edbcd8029e5d
import React, { Suspense, useEffect } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf/RenderPerf';
import { PROMOTION_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';

const modules = {
  moduleA: dynamic(() =>
    // eslint-disable-next-line extra-rules/no-commented-out-code
    import(/* webpackChunkName: "moduleA" */ '@tcp/core/src/components/common/molecules/ModuleA')
  ),
  moduleX: dynamic(() =>
    // eslint-disable-next-line extra-rules/no-commented-out-code
    import(/* webpackChunkName: "moduleX" */ '@tcp/core/src/components/common/molecules/ModuleX')
  ),
};

const PromoPDPBanners = ({ asPath, promos, isDynamicContentPDPEnabled, onLoad }) => {
  const hasMounted = useHasMounted();

  // Add the polyfill in a useEffect hook to ensure it's only run on the client side
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.requestAnimationFrame) {
      window.requestAnimationFrame =
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (f) {
          return setTimeout(f, 1000 / 60);
        };
    }
  }, []);

  useEffect(() => {
    // Call the onLoad prop when the component has mounted
    if (hasMounted && isDynamicContentPDPEnabled) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          onLoad();
        }, 500); // Delay of 500ms
      });
    }
  }, [hasMounted, isDynamicContentPDPEnabled]);

  return hasMounted || isDynamicContentPDPEnabled ? (
    <Suspense fallback={<p>loading...</p>}>
      {promos &&
        promos.length &&
        promos.map((promo) => {
          const { contentId, moduleName, data: slotData, ...others } = promo;
          const Module = modules[moduleName];
          return (
            Module && (
              <Module
                fullBleed
                key={contentId}
                data={promo}
                asPath={asPath}
                {...slotData}
                {...others}
              />
            )
          );
        })}
      {/* UX timer for when the lazy promos above resolve */}
      <RenderPerf.Measure name={PROMOTION_VISIBLE} />
    </Suspense>
  ) : null;
};

PromoPDPBanners.propTypes = {
  asPath: PropTypes.string,
  promos: PropTypes.arrayOf(
    PropTypes.shape({
      // Only including the most important property
      moduleName: PropTypes.string,
    })
  ),
};

PromoPDPBanners.defaultProps = {
  asPath: '',
  promos: [],
};

export default PromoPDPBanners;
